import { IDurationOptions, UnitDuration } from "@/helper/date/types/duration-options.type";

export const defaultUnitDuration: UnitDuration = {
  years: "ans",
  months: "m",
  weeks: "s",
  days: "j",
  hours: "h",
  minutes: "mins",
  seconds: "s",
};

export const formatTemplate = ["years", "months", "weeks", "days", "hours", "minutes"];

export const defaultDurationOptions: IDurationOptions = {
  format: formatTemplate,
  zero: true,
  units: defaultUnitDuration,
  delimiter: "",
};
